// export default Sidebar

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import "./Sidebar.css";
import { MdDashboard } from "react-icons/md";
// import { FaUserNinja } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { LiaIndustrySolid } from "react-icons/lia";
import { MdInterests, MdDomain } from "react-icons/md";
import { LiaSmsSolid } from "react-icons/lia";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { MdSocialDistance } from "react-icons/md";
import { HiMiniClipboardDocumentList } from "react-icons/hi2";
import { LiaCookieSolid } from "react-icons/lia";
import { FaUsers } from "react-icons/fa6";


function Sidebar({ isActive }) {
  // Get the current route path
  const location = useLocation();
  const currentPath = location.pathname;

  // Define menu items as an array for dynamic rendering
  const menuItems = [
    { path: "/", icon: <MdDashboard />, label: "Dashboard" },
    // { path: "/profile", icon: <FaUserNinja />, label: "Profile" },
    { path: "/ViewRegList", icon: <FiUsers />, label: "Manage Users" },
    { path: "/industries", icon: <LiaIndustrySolid />, label: "Manage Industries" },
    { path: "/interests", icon: <MdInterests />, label: "Manage  Interests" },
    { path: "/domains", icon: <MdDomain />, label: "Manage Domains" },
    { path: "/testimonials", icon: <LiaSmsSolid />, label: "Manage Testimonials" },
    { path: "/social-links", icon: <MdSocialDistance />, label: "Manage Social Media" },
    { path: "/termseditor", icon: <MdOutlineDocumentScanner />, label: "Terms & Conditions" },
    { path: "/privacypolicy", icon: <HiMiniClipboardDocumentList />, label: "Privacy Policy" },
    { path: "/cookieseditor", icon: <LiaCookieSolid />, label: "Cookies Policy" },
    { path: "/aboutus", icon: <FaUsers />, label: "About Us" },
    <LiaCookieSolid />
    
  ];

  return (
    <>
      <aside id="sidebar" className={`sidebar ${isActive ? "active" : ""}`}>
        <ul className="sidebar_Ul" id="Sidebar_Ul">
          {menuItems.map((item) => (
            <li
              key={item.path}
              className={`nav_item ${currentPath === item.path ? "active" : ""}`}
            >
              <Link to={item.path}>
                {item.icon}
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
}

export default Sidebar;
